// extracted by mini-css-extract-plugin
export default {"wrap":"dayOffCancelSubordinates_wrap__fKRIm","vacations__panel":"dayOffCancelSubordinates_vacations__panel__pAcrv"};